<template>

    <div class="register-page margin-auto">

        <div>

        <div class="register-box mx-auto text-center">
 <img style="max-width:100%;width:40%;" src="https://cdn.groevolve.com/logos/groevolve.com-logo-unstoppable.png" />
            <div class="card">
                <div class="card-body register-card-body">
                    <p class="login-box-msg text-red">Please enter your 6-Digit Code/Pin<br/> (check your email),<br/> and update your Details &amp; Password to proceed</p>
                    <div><span class="fas fa-email"></span>Your Email: <span class="text-primary" v-html="userdata.email"></span></div>
                    <errors :success="success" :failure="failure" :message="message" :loading="loading" />
<form autocomplete="off">
<div class="input-group">
                            <input autocomplete="off"  @blur="validateInput('pin')" type="number" class="form-control" v-model="pin" placeholder="Your Validation Pin" required>
                            <div class="input-group-append">
                                <div class="input-group-text">
                                <i class="fas fa-pin"></i>
                                </div>
                            </div>
                        </div>
   <p class="small text-danger mb-3" v-html="errors.pin"></p>


 <div class="input-group">
                            <input autocomplete="off"  type="text" @blur="validateInput('given_name')" class="form-control" v-model="given_name" placeholder="First Name" required>
                            <div class="input-group-append">
                                <div class="input-group-text">
                                <i class="fas fa-user"></i>
                                </div>
                            </div>
                        </div>
<p class="small text-danger mb-3" ></p>
 <div class="input-group">
                            <input autocomplete="off" type="text" @blur="validateInput('family_name')" class="form-control" v-model="family_name" placeholder="Last name" required>
                            <div class="input-group-append">
                                <div class="input-group-text">
                                <i class="fas fa-user"></i>
                                </div>
                            </div>
                        </div>
<p class="text-grey mt-3 mb-0" >Birth Date (or year):</p>
 <div class="input-group">
                            <input  onfocus="(this.type='date')" onblur="(this.type='text')" autocomplete="off" type="date" value="1950-01-01"  min="1940-01-01" @blur="validateInput('birthdate')" class="form-control" v-model="birthdate" placeholder="Birth Date" required>
                            <div class="input-group-append">
                                <div class="input-group-text">
                                <i class="fas fa-user"></i>
                                </div>
                            </div>
                        </div>
    <p class="small text-danger mb-3" v-html="errors.birthdate"></p>
                        <div class="input-group">
                            <input autocomplete="new-password" type="password" class="form-control" v-model="password" placeholder="Password" required>
                            <div class="input-group-append">
                                <div class="input-group-text">
                                <span class="fas fa-lock"></span>
                                </div>
                            </div>
                        </div>
                        <p class="small text-danger mb-3" v-html="errors.password"></p>

                        <div class="input-group">
                            <input autocomplete="off"  type="password" @keyup="validateInput('password_confirmation')" class="form-control" v-model="password_confirmation" placeholder="Retype password" required>
                            <div class="input-group-append">
                                <div class="input-group-text">
                                <span class="fas fa-lock"></span>
                                </div>
                            </div>
                        </div>
                        <p class="small text-danger mb-3" v-html="errors.password_confirmation"></p>

                        <div class="row">
                            <div class="col-12">
                                <button type="button" class="btn btn-primary btn-block" @click="update()">Update Details</button>
                            </div>
                            <!-- /.col -->
                        </div>
</form>

                    <!-- <a href="/login" class="text-center">I already have an account</a> -->
                </div>
                <!-- /.form-box -->
            </div><!-- /.card -->
        </div>
    </div>
    </div>
</template>

<script>
import axios from 'axios'
import Errors from '../partials/Errors.vue';
import Swal from 'sweetalert2';

export default {
    components: { Errors },
    name: "UpdateRegistration",
    data() {
        return {
            given_name: '',
            family_name: '',
            // fullname : '',
            email: '',
            birthdate: '',
            password: '',
            password_confirmation: '',
            success: false,
            failure: false,
            message: '',
            pin: '',
            token: document.head.querySelector('meta[name="csrf-token"]').getAttribute('content'),
            loading: false,
            errors: {
                pin:'',
                given_name:'',
                family_name: '',
                email: '',
                password: '',
                password_confirmation: ''
            },
            userdata:'',

        }
    },
    props:{
        user:'',
        // pinfo:'',
    },
    mounted(){
        this.userdata = JSON.parse(this.user);
        this.email = this.userdata.email;
        // this.fullname = this.userdata.name; if(this.fullname == 'NAME_PLACEHOLDER') this.fullname = '';
        // var pInfo = JSON.parse(this.pinfo);
        this.password = this.password_confirmation = this.pin = this.family_name = this.given_name = '';
        this.birthdate = '1950-01-01';

    },
    methods: {
        validateInput(element='all'){
            if(element == 'password_confirmation') this.errors.password = '';
            if(element == 'pin') this.errors.pin = '';
            // this.resetErrors();
            if(element =='pin') if(this.pin == '' && this.pin) { this.errors.pin = "Validation Pin required."; console.error("Invalid Pin");return false;}
            if(element =='given_name') if(this.given_name == '' || this.given_name.length <1) { this.errors.given_name = "Please enter your First Name"; console.error("FName < 1 chars");return false;}
            if(element =='family_name') if(this.family_name == '' || this.family_name.length <1) { this.errors.family_name = "Please enter your Last Name"; console.error("LName < 1 chars");return false;}
            if(element =='birthdate') if(this.birthdate == '' || this.birthdate.length <1) { this.errors.birthdate = "Please enter your Birth Date"; console.error("BirthDate < 1 chars");return false;}
            if(element =='password') if (this.password == '' || this.password.length<8) {this.errors.password = "Password length should be >= 8 characters"; console.error('Password lengths <8'); return false;}
            if(element =='password_confirmation') if(this.password != this.password_confirmation) {this.errors.password = "Password inputs don't match";   console.error("Password inputs don't match");return false;}
            return true;
        },
        resetErrors() {
            this.errors.given_name = null;
            this.errors.family_name = null;
            this.errors.email = null;
            this.errors.password = null;
            this.errors.birthdate = null;
            this.errors.pin = null;
        },
        update(event) {
            console.error('Clicked submit...');
            this.errors.given_name = null;
            this.errors.family_name = null;
            this.errors.email = null;
            this.errors.password = null;
            this.errors.birthdate = null;
           if(!this.validateInput()) return;
            // event.preventDefault();
            // Show the loading alert
            this.loading = true
            this.failure = false
            this.success = false
            console.error('Submiting...');
            // Register the user
            let user = {
                name: this.name,
                email: this.userdata.email,
                user_id: this.userdata.id,
                given_name: this.given_name,
                family_name: this.family_name,
                password: this.password,
                pin: this.pin,
                _token: this.token
            }
            // Empty the errors
            this.errors.name = null
            this.errors.email = null
            // this.errors.username = null
            this.errors.password = null
            axios.post('/reg/updregisternew', user)
            .then(res => {
                this.loading = false;
                this.success = true;
                this.message = res.data.message + '. Please Log in.';
                this.failure = false;
                this.updateToast(this.message);
                setTimeout(() => {
                    window.location.href = '/home'
                }, 7000)
            })
            .catch(err => {
                this.loading = false
                this.failure = true
                this.message = err.response.data.message
                this.success = false;
                this.updateToast(this.message + '. Please update inputs and retry');
                this.pin = '';
            })
        },

        updateToast(message, timer = 3000, icon='success') {
            const Toast = Swal.mixin({
                position: 'center',
                width: 500,
                showConfirmButton: true,
            });
            Toast.fire({
                icon: icon,
                title: message
            });
        },
    }
}
</script>
